<template>
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
  <path d="M4.23633 9.12109H14.7363M9.48633 3.87109V14.3711" stroke="#6782F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>